import { render, staticRenderFns } from "./comp_CategoriesMegaMenu-CategoriesList.vue?vue&type=template&id=bf150a0c&scoped=true&"
import script from "./comp_CategoriesMegaMenu-CategoriesList.vue?vue&type=script&lang=js&"
export * from "./comp_CategoriesMegaMenu-CategoriesList.vue?vue&type=script&lang=js&"
import style0 from "./comp_CategoriesMegaMenu-CategoriesList.vue?vue&type=style&index=0&id=bf150a0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf150a0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VHover,VIcon})
